export const getExt = (name) => name.split('.').pop().toLowerCase();

export const formatFileSize = (bytes) => {
  const mb = Math.round((bytes / (1024 * 1024)) * 10) / 10;
  return `${mb} MB`;
};
